import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'

type Props = {
  onClick: () => void
}

const CloseButton: FC<Props> = React.memo((props) => {
  const { onClick } = props

  return (
    <button className={styles.button__close} data-cy={'close-button'} onClick={onClick}>
      <img src={'/icon/close.svg'} alt={'閉じる'} />
    </button>
  )
})

export default CloseButton
